<section>
  <app-user-filter (filterEmmiter)="setFilter($event)"></app-user-filter>
  <app-user-list [filter]="filter"></app-user-list>
</section>
